import React from 'react';
import { Button } from '../../components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { format, isSameDay, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { cn } from '../../lib/utils';

export const DayNavigation = ({
  tripDays = [],
  currentDayIndex,
  currentDay,
  itinerary,
  onPreviousDay,
  onNextDay,
  onGoToDay,
}) => {
  const totalDays = tripDays?.length || 0;
  const currentDayNumber = currentDayIndex + 1;

  if (totalDays === 0 || !tripDays) return null;

  return (
    <div className="bg-slate-800 rounded-xl p-3 sm:p-4 border border-slate-700">
      {/* Day Indicator Pills - Horizontal scroll on mobile */}
      <div className="flex items-center gap-2 mb-4 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-hide">
        {tripDays?.map((day, index) => {
          const dayItems = itinerary?.filter(item => {
            const itemDate = typeof item.date === 'string' ? parseISO(item.date) : item.date;
            return isSameDay(itemDate, day);
          }) || [];
          const hasItems = dayItems.length > 0;

          return (
            <button
              key={index}
              onClick={() => onGoToDay(index)}
              className={cn(
                "flex flex-col items-center px-2 sm:px-3 py-2 rounded-lg transition-all flex-shrink-0",
                "min-w-[52px] sm:min-w-[60px]",
                index === currentDayIndex
                  ? "bg-orange-500 text-white"
                  : hasItems
                    ? "bg-slate-700 text-slate-200 hover:bg-slate-600"
                    : "bg-slate-800 text-slate-500 hover:bg-slate-700 border border-dashed border-slate-600"
              )}
              data-testid={`day-pill-${index}`}
            >
              <span className="text-[10px] sm:text-xs font-medium">Dia {index + 1}</span>
              <span className="text-[9px] sm:text-[10px] opacity-75">
                {format(day, 'dd/MM', { locale: ptBR })}
              </span>
              {hasItems && (
                <span className="text-[9px] sm:text-[10px] mt-0.5">
                  {dayItems.length} {dayItems.length === 1 ? 'item' : 'itens'}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Current Day Header */}
      <div className="flex items-center justify-between gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={onPreviousDay}
          disabled={currentDayIndex === 0}
          className="text-slate-400 hover:text-white h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0"
          data-testid="prev-day-btn"
        >
          <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" />
        </Button>

        <div className="text-center flex-1 min-w-0">
          <h2 className="text-lg sm:text-xl font-bold text-white truncate">
            Dia {currentDayNumber} de {totalDays}
          </h2>
          <p className="text-xs sm:text-sm text-orange-400 truncate">
            {currentDay && format(currentDay, "EEEE, dd 'de' MMMM", { locale: ptBR })}
          </p>
        </div>

        <Button
          variant="ghost"
          size="icon"
          onClick={onNextDay}
          disabled={currentDayIndex === totalDays - 1}
          className="text-slate-400 hover:text-white h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0"
          data-testid="next-day-btn"
        >
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" />
        </Button>
      </div>
    </div>
  );
};
